import {DialogContent, Stack, Typography, useTheme} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {useTranslate} from 'hooks';
import {DepositAccountMonthlyDepositDialogCancel} from './DepositAccountMonthlyDepositDialogCancel';
import {MonthlyDepositAccountFields} from './MonthlyDepositAccountFields';
import {MonthlyDepositAmountField} from './MonthlyDepositAmountField';
import {MonthlyDepositCancelCard} from './MonthlyDepositCancelCard';
import {MonthlyDepositScheduleFields} from './MonthlyDepositScheduleFields';
import {useMonthlyDepositForm} from './hooks/useMonthlyDepositForm';

export type {DepositAccountMonthlyDepositDialogState} from './hooks/useMonthlyDepositForm';

export const DepositAccountMonthlyDepositDialog = () => {
  const translate = useTranslate();
  const theme = useTheme();
  const {
    dialog,
    register,
    errors,
    selectedAccountId,
    isAutogiroRegistered,
    isAutogiroUnavailable,
    isBusy,
    isBusyOrSubmitting,
    isSubmitDisabled,
    amount,
    day,
    repeatDay,
    upcomingDate,
    setDay,
    handleAccountFieldChange,
    onSubmit,
    handleClose,
    cancelDialogOpen,
    openCancelDialog,
    closeCancelDialog,
  } = useMonthlyDepositForm();

  return (
    <>
      <BaseDialog
        open={dialog.open}
        onClose={handleClose}
        maxWidth={'sm'}
        header={translate('savings.deposit.picker.monthly.title')}
        actions={[
          {
            title: translate('common.cancel'),
            onClick: handleClose,
            disabled: isBusyOrSubmitting,
          },
          {
            color: 'primary',
            title: translate(
              isAutogiroRegistered
                ? 'savings.deposit.monthly.edit-action'
                : 'savings.deposit.monthly.action',
            ),
            onClick: onSubmit,
            disabled: isSubmitDisabled,
          },
        ]}>
        <DialogContent>
          <Stack spacing={2}>
            {isAutogiroUnavailable && (
              <Typography
                variant={'body1'}
                sx={{color: theme.palette.error.main}}>
                {translate('common.error.message')}
              </Typography>
            )}

            <MonthlyDepositAccountFields
              register={register}
              errors={errors}
              isAutogiroRegistered={isAutogiroRegistered}
              disabled={isAutogiroRegistered || isBusy || isAutogiroUnavailable}
              onAccountFieldChange={handleAccountFieldChange}
            />

            <MonthlyDepositAmountField
              register={register}
              errors={errors}
              amount={amount}
            />

            <MonthlyDepositScheduleFields
              day={day}
              repeatDay={repeatDay}
              upcomingDate={upcomingDate}
              onDayChange={setDay}
            />

            {isAutogiroRegistered && (
              <MonthlyDepositCancelCard onClick={openCancelDialog} />
            )}
          </Stack>
        </DialogContent>
      </BaseDialog>

      <DepositAccountMonthlyDepositDialogCancel
        open={cancelDialogOpen}
        accountId={selectedAccountId}
        onClose={closeCancelDialog}
        onDialogClose={dialog.onClose}
      />
    </>
  );
};
